import {atom} from "jotai";
import type {DiscoveryAuthUser} from "@/lib/getDiscoveryAuth";

/**
 * Logged-in Discovery visitor. Hydrated from `getDiscoveryAuth` outside
 * `"use cache"` (header and course route) so client CTAs can gate on auth
 * without another fetch. Null when logged out.
 */
export const discoveryUserAtom = atom<DiscoveryAuthUser | null>(null);
